<template>
    <a-space class="container page-settings" direction="vertical">
        <a-card title="头像上传">
            <a-form-model :label-col="{ span: 4 }" :wrapper-col="{ span: 14 }">
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item label="昵称">
                            <a-input v-model="user.user_name" placeholder="请输入昵称" :maxLength="14" style="width: 300px"/>
                        </a-form-model-item>
                        <a-form-model-item label="头像">
                            <ws-upload :url="user.face" @success="e => user.face = e.url" type="qrcode" scene="user_avatar"
                                @remove="() => user.face = ''"></ws-upload>
                        </a-form-model-item>
                        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                            <a-button type="primary" @click="onSaveUserInfo" :loading="userLoading">
                                保存
                            </a-button>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </a-card>
        <a-card title="封面图上传">
            <a-form-model :label-col="{ span: 4 }" :wrapper-col="{ span: 14 }">
                <a-row>
                    <a-col :span="12">
                        <p>说明：</p>
                        <p>1、封面图只允许上传小于2M的图片(比例：16:9 格式：jpg/jpeg/png)</p>
                        <p>2、其他平台没有单独上传封面图时，则将使用公用封面图</p>
                        <a-form-model-item label="公用封面图">
                            <ws-upload :url="cover_fix" @success="e => cover_fix = e.url" type="cover" scene="anchor_cover"
                                @remove="() => cover_fix = ''"></ws-upload>
                        </a-form-model-item>
                        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                            <a-button type="primary" @click="onSaveCoverFix">
                                保存
                            </a-button>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row>
                    <a-col :span="6" v-for="platform in platforms.filter(el => el.type == 1)" :key="platform.key">
                        <a-form-model-item :label="platform.text">
                            <ws-upload :url="platform.url" :prefix="platform.key" type="cover" scene="anchor_cover"
                                @success="e => onSaveQrcode(platform, e, true)"
                                @remove="onSaveQrcode(platform, { url: '' }, true)"></ws-upload>
                        </a-form-model-item>
                        <!-- <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                            <a-button type="primary" @click="onSaveQrcode(platform)">
                                保存
                            </a-button>
                        </a-form-model-item> -->
                    </a-col>
                </a-row>
            </a-form-model>
        </a-card>
        <a-card title="二维码上传" v-if="platforms.length > 0">
            <p>二维码只允许上传小于2M的图片(比例：1:1 格式：jpg/jpeg/png)</p>
            <a-form-model :label-col="{ span: 4 }" :wrapper-col="{ span: 14 }">
                <a-row>
                    <a-col :span="6" v-for="platform in platforms.filter(el => el.type != 1)" :key="platform.key">
                        <a-form-model-item :label="platform.text">
                            <ws-upload :url="platform.url" :prefix="platform.key" type="qrcode" scene="user_avatar"
                                @success="e => onSaveQrcode(platform, e)"
                                @remove="onSaveQrcode(platform, { url: '' })"></ws-upload>
                        </a-form-model-item>
                        <!-- <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                            <a-button type="primary" @click="onSaveQrcode(platform)">
                                保存
                            </a-button>
                        </a-form-model-item> -->
                    </a-col>
                </a-row>
            </a-form-model>
        </a-card>
    </a-space>
</template>
<script>
import { mapState } from "vuex";
import wsUpload from "@/components/WsUpload";

export default {
    components: { wsUpload },
    data() {
        return {
            saveUrl: '',
            loading: false,
            cover_fix: '',
            platforms: [],
            user:{
                face:'',
                user_name:''
            },
            userLoading:false
        };
    },
    computed: {
        ...mapState(["minfo", "anchors", "config"]),
    },
    created() {
        this.$store.subscribe((mutation, state) => {
            if (mutation.type == 'MEMBER') {
                this.user.face = state.minfo.face
                this.user.user_name = state.minfo.username
                if (state.minfo.cover_fix) {
                    this.cover_fix = state.minfo.cover_fix
                    this.saveUrl = state.minfo.cover_fix
                }
            }
        })
        this.cover_fix = this.minfo.cover_fix
        this.saveUrl = this.minfo.cover_fix
        this.user.face = this.minfo.face
        this.user.user_name = this.minfo.username
    },
    mounted() { this.getQrcodes() },
    methods: {
        async getQrcodes() {
            const response = await this.$api.get(`/get_qrcode_info`)
            if (response.code == 200) {
                this.platforms = response.data || []
            }
        },
        async onSaveCoverFix() {
            this.loading = true

            const obj = {
                cover_fix: this.cover_fix
            }

            this.platforms.filter(el => el.type == 1).forEach(el => {
                obj[el.key] = el.url
            })

            const response = await this.$api.post(`/update_user`, obj).catch(() => this.loading = false)
            if (response.code == 200) {
                this.$store.dispatch('getMemberInfo');
                this.$message.success('更新成功')

                this.saveUrl = obj.cover_fix
            }
            this.loading = false
        },
        async onSaveQrcode(platform, data, isKey) {
            // this.loading = true

            const postData = {
                [platform.key]: data.url, cover_fix: this.saveUrl || ''
            }

            if (isKey !== true) {
                delete postData.cover_fix
            } else {
                this.platforms.filter(el => el.type == 1).forEach(el => {
                    if (el.key !== platform.key) {
                        postData[el.key] = el.url
                    }
                })
            }
            const response = await this.$api.post(`/update_user`, postData).catch(() => this.loading = false)
            if (response.code == 200) {
                const { key, ...filteredData } = data
                Object.assign(platform, filteredData)
                // this.$store.dispatch('getMemberInfo');
                this.$message.success('更新成功')
            }
            // this.loading = false
        },
        async onSaveUserInfo() {
            this.userLoading = true
            const response = await this.$api.post(`/update_user`, this.user).catch(() => this.userLoading = false)
            if (response.code == 200) {
                this.$store.dispatch('getMemberInfo');
                this.$message.success('更新成功')
            }
            this.userLoading = false
        }
    },
};
</script>
<style lang="less">
.page-settings {
    .a-card {
        width: 100%;
    }
}
</style>
